export default [
    {
        path: '/customer/tag',
        props: true,
        component: () => import('@/views/Customer/Tag'),
    },
];